export const productionConfig = {
    triviaV2Service: `https://trivia.penroseza.com`,
    campaignHubService: `${process.env.VUE_APP_CAMPAIGN_HUB_SERVICE}`,
    dailyFiveRedirectUrl: `${process.env.VUE_APP_DAILY_FIVE_REDIRECT_URL}`,
    quizIncTermsConditionsHub: `${process.env.VUE_APP_QUIZ_INC_TERMS_CONDITIONS_URL}`,
}

export const stagingConfig = {
    triviaV2Service: `https://staging-trivia.penroseza.com`,
    campaignHubService: `${process.env.VUE_APP_CAMPAIGN_HUB_SERVICE}`,
    dailyFiveRedirectUrl: `${process.env.VUE_APP_DAILY_FIVE_REDIRECT_URL}`,
    quizIncTermsConditionsHub: `${process.env.VUE_APP_QUIZ_INC_TERMS_CONDITIONS_URL}`,
}

const environment = getEnvironment()

export const environmentConfig = getEnvObject();

function getEnvironment() {
    let base_url = window.location.origin;
    if (base_url.includes('staging')) return 'staging'
    if (base_url.includes('localhost')) return 'development'
    else return 'production'
}

function getEnvObject() {
    if (environment === 'staging') return stagingConfig
    if (environment === 'development') return productionConfig
    if (environment === 'production') return productionConfig
}
